const GET_HOME_SUBSCRIPTIONS = `
  query Home {
    account {
      subscriptions {
        type
        state
      }
    }
  }
`;

export default GET_HOME_SUBSCRIPTIONS;
